module.exports = __webpack_public_path__ + "media/01-sol-dopamine.63928c8b.mp4";